import { Component, HostListener, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SnackBarData } from "src/app/common/components/snackbar/model/snackbar.model";
import { SnackBarService } from "src/app/common/components/snackbar/snackbar.service";
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import {
  ConfirmDialogComponent,
  ConfirmDialogModel,
} from "src/app/common/components/confirm-dialog/confirm-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { DirtyCheck } from "src/app/common/guards/form-deactivate.guard";
import { ShopinfoService } from "src/app/pages/common/system/shopinfo/shopinfo.service";
import { DepartmentService } from "src/app/pages/common/system/department/department.service";
import { FormsModule } from "@angular/forms";
import moment from "moment";
import { HourlySalesReportService } from "../hourly-sales-report/hourly-sales-report.service";
import { UserInfoModel } from "src/app/common/models/user-info.model";
import { AppConstants } from "src/app/common/app.constants";
import { TerminalService } from "src/app/pages/common/system/terminal/terminal.service";
import { AccessLogService } from "../access-log/access-log.service";
import { SaleItemService } from "src/app/pages/common/products/sale-item/sale-item.service";
import { ItemCategoryService } from "src/app/pages/common/products/item-category/item-category.service";
import { SalesReportByGroupService } from "./sales-report-by-group.service";
import { PermissionService } from "src/app/auth/permission.service";

@Component({
  selector: 'app-sales-report-by-group',
  standalone: false,
  templateUrl: './sales-report-by-group.component.html',
  styleUrls: ['./sales-report-by-group.component.scss']
})
export class SalesReportByGroupComponent {
  user: UserInfoModel | undefined;
  title: string = "Sales Report By Groups";
  IsDownloading: boolean = false;
  editForm: FormGroup;
  currentYear: number;
  selectedYear: any;
  weeks: any[] = [];
  financialYears: any[] = [];
  years: number[] = [];
  shopsIsOpen = false;
  orderSourceIsOpen = false;
  terminalIsOpen = false;
  casherSourceIsOpen = false;
  itemSourceIsOpen = false;
  mainGroupSourceIsOpen = false;
  groupSourceIsOpen = false;
  curFinYear!: string;
  daysOfWeek: string[] = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
  hours: string[] = Array.from({ length: 24 }, (_, i) =>
    i.toString().padStart(2, "0")
  );
  fromHour: string = "00";
  toHour: string = "00";
  shop_id: any;
  shop_name: any;
  permission: any;
  departmentValidationMessage: any;
  departmentSelectionInvalid: boolean = false;
  showSelectedTerminalOnly = false;
  showSelectedCashierOnly = false;
  showSelectedMainGroupOnly = false;
  showSelectedGroupOnly = false;
  showSelectedItemOnly = false;

  isExpandedOrder = false;
  isExpandedTerminal = false;
  isExpandedCashier = false;
  isExpandedMainGroup = false;
  isExpandedGroup = false;
  isExpandedItem = false;
  isExpandedSort = false;

  orderSourceListData: any = [];
  terminalListData: any = [];
  usersListData: any = [];
  itemListData: any = [];
  groupListData: any = [];
  mainGroupListData: any = [];

  constructor(
    private router: Router,
    private builder: FormBuilder,
    private route: ActivatedRoute,
    private hourlySalesReportService: HourlySalesReportService,
    private salesReportByGrouptService: SalesReportByGroupService,
    private snackBarService: SnackBarService,
    private ShopinfoService: ShopinfoService,
    private departmentService: DepartmentService,
    public dialog: MatDialog,
    private ternimalService: TerminalService,
    private accessLogService: AccessLogService,
    private saleItemService: SaleItemService,
    private permissionService: PermissionService,
    private itemCategoryService: ItemCategoryService
  ) {

    const today= new Date();
    this.editForm = this.builder.group(
      {
        period_from: this.builder.control(today, Validators.required),
        period_to: this.builder.control(today, Validators.required),
        days: this.builder.group({}),
        percentage_calculation: this.builder.control(0),

        summary_report: this.builder.control(true),
        sortBy: this.builder.control('sale_item_name'),
        orderBy: this.builder.control('asc'),
        terminalFilter: this.builder.control(''),
        cashierFilter: this.builder.control(''),
        regionFilter: this.builder.control(''),
        departmentFilter: this.builder.control(''),
        mainGroupFilter: this.builder.control(''),
        groupFilter: this.builder.control(''),
        itemFilter: this.builder.control(''),
        sortBasedOnCode: this.builder.control(false)
      },
      { validators: this.hourRangeValidator() }
    );

    this.currentYear = new Date().getFullYear();
    const daysGroup = this.editForm.get("days") as FormGroup;
    this.daysOfWeek.forEach((day) => {
      daysGroup.addControl(day, new FormControl(true));
    });

    this.permission = this.permissionService.getPagePermission("sales-report-by-group");
  }

  ngOnInit(): void {
    this.TerminalList();
    this.UsersList();
    this.itemList();
    this.groupList();
    this.mainGroupList();
    let sesUser = sessionStorage.getItem(AppConstants.SESSION_VAR_USER);
    this.user = sesUser !== null ? JSON.parse(sesUser) : undefined;
    console.log(this.user);
    this.setupFilterListeners();
  }

  setupFilterListeners(): void {
    // Listeners can be added here if needed for specific logic,
    // otherwise the getters handle filtering based on form value.
  }

  saveToSessionStorage(): void {
    // Implement session storage saving if required
  }

  onListSelectionChange(type: string): void {
    // Handle selection change logic
    this.saveToSessionStorage();
  }

  selectedDays(): string[] {
    const days = this.editForm.get("days")?.value;
    return Object.keys(days).filter((day) => days[day]);
  }

  hourRangeValidator(): ValidatorFn {
    return (group: AbstractControl): { [key: string]: any } | null => {
      const from = group.get("fromHour")?.value;
      const to = group.get("toHour")?.value;

      if (from != null && to != null && from > to) {
        return { invalidHourRange: true };
      }
      return null;
    };
  }

  getCurrentWeek(weeks: any[]): any {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return weeks.find((week) => {
      const startDate = new Date(week.start_date);
      const endDate = new Date(week.end_date);
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(0, 0, 0, 0);

      return today >= startDate && today <= endDate;
    });
  }

  sortOptions = [
    { value: "shop_name", label: "Shop Name" },
    { value: "this_year_this_week_sales", label: "This Year Sales" },
    { value: "last_year_this_week_sales", label: "Last Year Sales" },
    { value: "this_week_cust_orders", label: "This Year Customer Orders" },
    { value: "last_year_cus_order", label: "Last Year Customer Orders" },
    { value: "this_week_labour_cost", label: "This Year Labour Cost" },
    { value: "last_year_this_week_labour_cost", label: "Last Year Labour Cost" }
  ];

  sortOrderOptions = [
    { value: "asc", label: "Ascending" },
    { value: "desc", label: "Descending" }
  ];

  onYearChange(): void {
    this.selectedYear = this.editForm.get("year")?.value;
    console.log("Selected Year:", this.selectedYear);

    const selectedFinYear = this.financialYears.find(
      (fy) => fy.year === this.selectedYear
    );

    if (selectedFinYear) {
      this.weeks = selectedFinYear.weeks.map((week: any) => ({
        ...week,
        displayText: `${this.padWeekNumber(week.week_no)} (${week.start_date} - ${week.end_date})`
      }));

      if (this.weeks.length > 0) {
        this.editForm.get("week_no")?.setValue(this.weeks[0].week_no);
      }
    } else {
      this.weeks = [];
      this.editForm.get("week_no")?.setValue(null);
    }
  }

  padWeekNumber(weekNo: number): string {
    return weekNo.toString().padStart(2, "0");
  }

  TerminalList(): void {
    let requestData = {
      search: {
        filters: { filter: [], scope: { offset: 0, limit: 1000000 } },
        sort: [{ column: "name", order: "ASC" }]
      }
    };

    this.ternimalService.getTerminalList(requestData).subscribe(
      (response: any) => {
        this.terminalListData = [];
        var index = 0;
        response.data.terminals.forEach((item: any) => {
          if (!item.code) {
            console.warn(`Terminal ID ${item.id} is missing code field`, item);
          }
          var data = { index: index, item: item, selected: false };
          this.terminalListData.push(data);
          index++;
        });
        console.log('Terminal List Data:', JSON.stringify(this.terminalListData));
      },
      (error: any) => {
        console.error('Error fetching terminal list:', error);
        this.snackBarService.openSnackBar({
          message: 'Failed to load terminal list',
          type: 'error'
        } as SnackBarData);
      }
    );
  }

  UsersList(): void {
    let requestData = {
      search: {
        filters: { filter: [], scope: { offset: 0, limit: 1000000 } },
        sort: [{ column: "name", order: "ASC" }]
      }
    };

    this.accessLogService.getUsers().subscribe(
      (response: any) => {
        this.usersListData = [];
        var index = 0;
        response.data.users.forEach((item: any) => {
          var data = { index: index, item: item, selected: false };
          this.usersListData.push(data);
          index++;
        });
        console.log('Users List Data:', this.usersListData);
      },
      (error: any) => {
        console.error('Error fetching users list:', error);
        this.snackBarService.openSnackBar({
          message: 'Failed to load users list',
          type: 'error'
        } as SnackBarData);
      }
    );
  }

  itemList(): void {
    let requestData = {
      search: {
        filters: { filter: [], scope: { offset: 0, limit: 1000000 } },
        sort: [{ column: "sale_item.name", order: "ASC" }]
      }
    };

    this.saleItemService.getList(requestData).subscribe(
      (response: any) => {
        this.itemListData = [];
        var index = 0;
        response.data.items.forEach((item: any) => {
          var data = { index: index, item: item, selected: false };
          this.itemListData.push(data);
          index++;
        });
        console.log('Item List Data:', this.itemListData);
      },
      (error: any) => {
        console.error('Error fetching item list:', error);
        this.snackBarService.openSnackBar({
          message: 'Failed to load item list',
          type: 'error'
        } as SnackBarData);
      }
    );
  }

  groupList(): void {
    let requestData = {
      search: {
        filters: { filter: [], scope: { offset: 0, limit: 1000000 } },
        sort: [{ column: "item_classes.name", order: "ASC" }]
      }
    };

    this.itemCategoryService.getList(requestData).subscribe(
      (response: any) => {
        this.groupListData = [];
        var index = 0;
        response.data.categories.forEach((item: any) => {
          if (item.is_super_class_id != null && item.is_super_class_id !== 0) {
            var data = { index: index, item: item, selected: false };
            this.groupListData.push(data);
            index++;
          }
        });
        console.log("Group List Data:", this.groupListData);
      },
      (error: any) => {
        console.error("Error fetching group list:", error);
        this.snackBarService.openSnackBar({
          message: 'Failed to load group list',
          type: 'error'
        } as SnackBarData);
      }
    );
  }

  mainGroupList(): void {
    let requestData = {
      search: {
        filters: { filter: [], scope: { offset: 0, limit: 1000000 } },
        sort: [{ column: "item_classes.name", order: "ASC" }]
      }
    };

    this.itemCategoryService.getList(requestData).subscribe(
      (response: any) => {
        this.mainGroupListData = [];
        let index = 0;
        response.data.categories.forEach((item: any) => {
          if (item.is_super_class_id === null || item.is_super_class_id === 0) {
            let data = { index: index, item: item, selected: false };
            this.mainGroupListData.push(data);
            index++;
          }
        });
        console.log("Main Group List Data:", this.mainGroupListData);
      },
      (error: any) => {
        console.error("Error fetching main group list:", error);
        this.snackBarService.openSnackBar({
          message: 'Failed to load main group list',
          type: 'error'
        } as SnackBarData);
      }
    );
  }

  toggleContent(divData: string): void {
    if (divData == "expensetype") {
      this.isExpandedOrder = !this.isExpandedOrder;
    }
    if (divData == "terminaltype") {
      this.isExpandedTerminal = !this.isExpandedTerminal;
    }
    if (divData == "cashiertype") {
      this.isExpandedCashier = !this.isExpandedCashier;
    }
    if (divData == "maingrouptype") {
      this.isExpandedMainGroup = !this.isExpandedMainGroup;
    }
    if (divData == "grouptype") {
      this.isExpandedGroup = !this.isExpandedGroup;
    }
    if (divData == "itemtype") {
      this.isExpandedItem = !this.isExpandedItem;
    }
    if (divData == "sorttype") {
      this.isExpandedSort = !this.isExpandedSort;
    }
  }

  getSelectedCount(sourceList: any[]): any {
    var count = 0;
    sourceList.forEach((el) => {
      if (el.selected) {
        count++;
      }
    });
    return sourceList.length + "/" + (count > 0 ? count : "ALL");
  }



  onShopSelectionChange(selectionData: any): void { }

  get selectedOrderSourcesCount(): number {
    return this.orderSourceListData?.filter((item: any) => item.selected)?.length || 0;
  }

  get selectedTerminalSourcesCount(): number {
    return this.terminalListData?.filter((item: any) => item.selected)?.length || 0;
  }

  get selectedCasheirSourcesCount(): number {
    return this.usersListData?.filter((item: any) => item.selected)?.length || 0;
  }

  get selectedMainGroupSourcesCount(): number {
    return this.mainGroupListData?.filter((item: any) => item.selected)?.length || 0;
  }

  get selectedGroupSourcesCount(): number {
    return this.groupListData?.filter((item: any) => item.selected)?.length || 0;
  }

  get selectedItemSourcesCount(): number {
    return this.itemListData?.filter((item: any) => item.selected)?.length || 0;
  }

  // --- Terminal ---
  get filteredTerminalListData() {
    let filteredList = this.terminalListData;
    if (this.showSelectedTerminalOnly) {
      filteredList = filteredList.filter((item: any) => item.selected);
    }
    const filter = this.editForm.get('terminalFilter')?.value?.toLowerCase() || '';
    if (filter) {
      filteredList = filteredList.filter((item: { item: { name: string; }; }) =>
        item.item.name.toLowerCase().includes(filter)
      );
    }
    return filteredList;
  }

  toggleSelectAllTerminal() {
    const allSelected = this.terminalListData.every((item: any) => item.selected);
    this.terminalListData.forEach((item: any) => (item.selected = !allSelected));
    this.saveToSessionStorage();
  }

  getSelectAllIconTerminal(): string {
    const allSelected = this.terminalListData.every((item: any) => item.selected);
    const someSelected = this.terminalListData.some((item: any) => item.selected);
    if (allSelected) return 'check_box';
    if (someSelected) return 'indeterminate_check_box';
    return 'check_box_outline_blank';
  }

  // --- Cashier ---
  get filteredCashierListData() {
    let filteredList = this.usersListData;
    if (this.showSelectedCashierOnly) {
      filteredList = filteredList.filter((item: any) => item.selected);
    }
    const filter = this.editForm.get('cashierFilter')?.value?.toLowerCase() || '';
    if (filter) {
      filteredList = filteredList.filter((item: { item: { name: string; }; }) =>
        item.item.name.toLowerCase().includes(filter)
      );
    }
    return filteredList;
  }

  toggleSelectAllCashier() {
    const allSelected = this.usersListData.every((item: any) => item.selected);
    this.usersListData.forEach((item: any) => (item.selected = !allSelected));
    this.saveToSessionStorage();
  }

  getSelectAllIconCashier(): string {
    const allSelected = this.usersListData.every((item: any) => item.selected);
    const someSelected = this.usersListData.some((item: any) => item.selected);
    if (allSelected) return 'check_box';
    if (someSelected) return 'indeterminate_check_box';
    return 'check_box_outline_blank';
  }

  // --- Main Group ---
  get filteredMainGroupListData() {
    let filteredList = this.mainGroupListData;
    if (this.showSelectedMainGroupOnly) {
      filteredList = filteredList.filter((item: any) => item.selected);
    }
    const filter = this.editForm.get('mainGroupFilter')?.value?.toLowerCase() || '';
    if (filter) {
      filteredList = filteredList.filter((item: { item: { name: string; }; }) =>
        item.item.name.toLowerCase().includes(filter)
      );
    }
    return filteredList;
  }

  toggleSelectAllMainGroup() {
    const allSelected = this.mainGroupListData.every((item: any) => item.selected);
    this.mainGroupListData.forEach((item: any) => (item.selected = !allSelected));
    this.saveToSessionStorage();
  }

  getSelectAllIconMainGroup(): string {
    const allSelected = this.mainGroupListData.every((item: any) => item.selected);
    const someSelected = this.mainGroupListData.some((item: any) => item.selected);
    if (allSelected) return 'check_box';
    if (someSelected) return 'indeterminate_check_box';
    return 'check_box_outline_blank';
  }

  // --- Group ---
  get filteredGroupListData() {
    let filteredList = this.groupListData;
    if (this.showSelectedGroupOnly) {
      filteredList = filteredList.filter((item: any) => item.selected);
    }
    const filter = this.editForm.get('groupFilter')?.value?.toLowerCase() || '';
    if (filter) {
      filteredList = filteredList.filter((item: { item: { name: string; }; }) =>
        item.item.name.toLowerCase().includes(filter)
      );
    }
    return filteredList;
  }

  toggleSelectAllGroup() {
    const allSelected = this.groupListData.every((item: any) => item.selected);
    this.groupListData.forEach((item: any) => (item.selected = !allSelected));
    this.saveToSessionStorage();
  }

  getSelectAllIconGroup(): string {
    const allSelected = this.groupListData.every((item: any) => item.selected);
    const someSelected = this.groupListData.some((item: any) => item.selected);
    if (allSelected) return 'check_box';
    if (someSelected) return 'indeterminate_check_box';
    return 'check_box_outline_blank';
  }

  // --- Item ---
  get filteredItemListData() {
    let filteredList = this.itemListData;
    if (this.showSelectedItemOnly) {
      filteredList = filteredList.filter((item: any) => item.selected);
    }
    const filter = this.editForm.get('itemFilter')?.value?.toLowerCase() || '';
    if (filter) {
      filteredList = filteredList.filter((item: { item: { name: string; }; }) =>
        item.item.name.toLowerCase().includes(filter)
      );
    }
    return filteredList;
  }

  toggleSelectAllItem() {
    const allSelected = this.itemListData.every((item: any) => item.selected);
    this.itemListData.forEach((item: any) => (item.selected = !allSelected));
    this.saveToSessionStorage();
  }

  getSelectAllIconItem(): string {
    const allSelected = this.itemListData.every((item: any) => item.selected);
    const someSelected = this.itemListData.some((item: any) => item.selected);
    if (allSelected) return 'check_box';
    if (someSelected) return 'indeterminate_check_box';
    return 'check_box_outline_blank';
  }

  navigateToWeeklyReport() {
    this.router.navigate(["/weekly-result-store-report-view"]);
  }

  exportClicked(): void {
    // Date range check (like daily-sales)
    const from = this.editForm.get("period_from")?.value;
    const to = this.editForm.get("period_to")?.value;
    if (from && to) {
      const fromDate = new Date(from);
      const toDate = new Date(to);
      const diff = (toDate.getTime() - fromDate.getTime()) / (1000 * 60 * 60 * 24);
      if (diff >= 365) {
        this.snackBarService.openSnackBar({
          message: "Please choose a date range shorter than 365 days.",
          type: "warn"
        } as SnackBarData);
        return;
      }
    }

    if (this.editForm.valid) {
      try {
        const selectedTerminalCodes = this.terminalListData
          .filter((shop: any) => shop.selected)
          .map((shop: any) => {
            if (!shop.item.code) {
              console.error(`Terminal ID ${shop.item.id} is missing code field`, shop.item);
              throw new Error(`Terminal code missing for ID ${shop.item.id}`);
            }
            return shop.item.code;
          });
        const selectedCashierIds = this.usersListData
          .filter((shop: any) => shop.selected)
          .map((shop: any) => shop.item.id);
        const selectedMainGroupIds = this.mainGroupListData
          .filter((shop: any) => shop.selected)
          .map((shop: any) => shop.item.id);
        const selectedGroupIds = this.groupListData
          .filter((shop: any) => shop.selected)
          .map((shop: any) => shop.item.id);
        const selectedItemIds = this.itemListData
          .filter((shop: any) => shop.selected)
          .map((shop: any) => shop.item.id);

        console.log('Selected Terminal Codes:', selectedTerminalCodes);

        const terminalCodes = selectedTerminalCodes.length > 0 ? selectedTerminalCodes : [];
        const cashierIds = selectedCashierIds.length > 0 ? selectedCashierIds : [];
        const mainGroupIds = selectedMainGroupIds.length > 0 ? selectedMainGroupIds : [];
        const groupIds = selectedGroupIds.length > 0 ? selectedGroupIds : [];
        const itemIds = selectedItemIds.length > 0 ? selectedItemIds : [];

        var rawDateFrom = this.editForm.get("period_from")?.value;
        var formattedDateFrom = moment(rawDateFrom).format("YYYY-MM-DD");
        var rawDateTo = this.editForm.get("period_to")?.value;
        var formattedDateTo = moment(rawDateTo).format("YYYY-MM-DD");
        var days = this.selectedDays();

        if (this.user?.shop_info !== null && this.user?.shop_info !== undefined) {
          this.shop_id = this.user?.shop_info.id;
          this.shop_name = this.user?.shop_info.name;
        }

        const reportData = {
          dateFrom: formattedDateFrom,
          dateTo: formattedDateTo,
          Shift: 5,
          terminalId: terminalCodes,
          cashierFrom: cashierIds,
          mainGroupFrom: mainGroupIds,
          groupFrom: groupIds,
          itemFrom: itemIds,
          sortBy: this.editForm.get("sortBy")?.value,
          orderBy: this.editForm.get("orderBy")?.value,
          sortBasedOnCode: this.editForm.get("sortBasedOnCode")?.value ? 1 : 0,
          shopName: this.shop_name
        };

        console.log('Report Data Payload:', JSON.stringify(reportData));

        if (reportData) {
          this.IsDownloading = true;
          this.salesReportByGrouptService
            .exportSalesReport(reportData)
            .subscribe({
              next: (response) => {
                // Handle "No data found" response
                const reader = new FileReader();
                reader.onload = () => {
                  try {
                    const text = reader.result as string;
                    const json = JSON.parse(text);
                    if (json.status === 'NO_DATA_FOUND') {
                      let snackBarData: SnackBarData = {
                        message: 'No data found.',
                        title: 'No Data!!!',
                        type: 'warn'
                      }
                      this.IsDownloading = false;
                      this.snackBarService.openSnackBar(snackBarData);
                      return;
                    }
                  } catch (e) {
                    // Not JSON, treat as file
                    const blob = new Blob([response], {
                      type: "application/vnd.ms-excel"
                    });
                    const shopName = this.shop_name.replace(/\s+/g, '_');
                    const timestamp = moment().format('YYYYMMDDHHmmss');
                    const filename = `Sales_Report_By_Groups_${shopName}_${timestamp}.xls`;
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = filename;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    window.URL.revokeObjectURL(url);
                    this.IsDownloading = false;

                    return;
                  }
                  // If JSON but not NO_DATA_FOUND, treat as error
                  this.IsDownloading = false;
                };
                reader.readAsText(response);
              },
              error: (error) => {
                this.IsDownloading = false;
                console.error('Export error:', error.message);
                this.snackBarService.openSnackBar({
                  message: error.message === 'No data found' ? 'No data found' : 'Failed to generate report',
                  type: 'error'
                } as SnackBarData);
              }
            });
        }
      } catch (error: any) {
        this.IsDownloading = false;
        console.error('Export preparation error:', error.message);
        this.snackBarService.openSnackBar({
          message: error.message || 'Failed to prepare report data',
          type: 'error'
        } as SnackBarData);
      }
    } else {
      this.editForm.markAllAsTouched();
    }
  }
}